import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';

import {
    getEmptyStateTextForType,
    getEmptyStateSubTextForType,
    getEmptyStateIconForType,
} from './constants';
import type {SequenceTemplateType} from './constants';

import styles from './templates.module.css';

type Props = {
    templateType: SequenceTemplateType;
};

export function EmptyListView(props: Props) {
    const {templateType} = props;

    // Flow requires we have a value for these strings. They can be undefined
    // for archived templates, but we don't mount this component for the
    // archived template section, so that shouldn't be an issue.
    const mainText = getEmptyStateTextForType(templateType) || '';
    const subText = getEmptyStateSubTextForType(templateType) || '';
    const Icon = getEmptyStateIconForType(templateType);

    return (
        <tbody>
            <tr>
                <td colSpan={4}>
                    <EmptyStateSmall
                        icon={
                            <div className={styles['empty-icon-wrapper']}>
                                {Icon ? <Icon size={38} fill={colors.offWhite} /> : undefined}
                            </div>
                        }
                        title={mainText}
                        subtitle={subText}
                    />
                </td>
            </tr>
        </tbody>
    );
}
